'use strict';
module.exports = [
    function() {

        return {
            controller: ['$http', '$scope', yTagsCtrl],
            controllerAs: 'ctrl',
            template: `
            <md-chips
                ng-model="model"
                md-autocomplete-snap
                md-transform-chip="ctrl.blockLocal($chip)"
                md-on-remove="ctrl.remove($index)"
                readonly="rmReadOnly"
            >
                <md-autocomplete
                    md-selected-item="selected"
                    md-search-text="searchText"
                    md-items="tag in ctrl.search(searchText)"
                    md-item-text="tag.name"
                    md-selected-item-change="searchText= ''"
                    placeholder="{{ rmPlaceholder }}"
                    ng-model-options="{ debounce: 200 }"
                    ng-disabled="rmReadOnly"
                >
                    <span md-highlight-text="searchText">{{tag.name}}</span>
                </md-autocomplete>
                <md-chip-template>
                    <span>{{ (!$chip.id) ? $chip : $chip.name}}</span>
                </md-chip-template>
            </md-chips>
            `,
            scope: {
                yModel: '=model',
                rmReadOnly: '=',
                rmPlaceholder: '@',
            },
            restrict: 'E',
        };
    }];

class yTagsCtrl {
    constructor($http, $scope) {
        this.$http = $http;
        this.$scope = $scope;

        $scope.model = $scope.yModel.toArray();

        this.observeHandler = this.observer.bind(this);
        $scope.yModel.observe(this.observeHandler);
        $scope.$on('$destroy', this.destroy.bind(this));
    }

    observer(event) {
        if(event.type == 'insert') {
            for(let i = 0; i < event.length; i++) {
                this.$scope.model.splice(event.index + i, 0, event.values[i]);
            }
        } else if(event.type == 'delete') {
            for(let i = 0; i < event.length; i++) {
                let index = this.$scope.model.indexOf(event.values[i]);
                if (index >= 0) {
                    this.$scope.model.splice(index, 1);
                }
            }
        }
    }

    search(query) {
        return this.$http.get('/tags/search/' + encodeURIComponent(query)).then(result => {
            return result.data;
        });
    }

    add(value) {
        let find = this.$scope.model.find((element) => {
            let checkEl;
            if(typeof element === 'object') {
                checkEl = element.name;
            } else {
                checkEl = element;
            }

            let checkVal;
            if(typeof value === 'object') {
                checkVal = value.name;
            } else {
                checkVal = value;
            }

            return checkEl == checkVal;
        });
        if (find === undefined) {
            this.$scope.yModel.push([value]);
            this.$scope.model.push(value);
        }
        
    }

    remove(index) {
        this.$scope.yModel.delete(index, 1)
    }

    blockLocal($chip) {
        this.add($chip);//just send the chip to add, because we want to add it to y
        return null;
    }

    destroy() {
        this.$scope.yModel.unobserve(this.observeHandler);
    }
}
